import React, { useState, useEffect, Fragment } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Card, Row, Col, Button, Table } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { useConfirmModalState } from 'global/confirmModalState';
import { RESPONSE_CODE } from 'types/const';

// api
import { resultDetail } from 'api/haccp/monitoring/commonApi';

/**
 * 제품 - 검사결과 상세페이지
 */
const Detail = () => {
  /* router info*/
  const history = useHistory();
  const { seq } = useParams();
  const { state } = useLocation();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  // 의뢰정보
  const [requestInfo, setRequestInfo] = useState({});
  //  검사결과 원본 Data
  const [originData, setOriginData] = useState([]);
  // 검사결과 Data
  const [resultData, setResultData] = useState([]);

  /* event */

  // 제품-검사결과 목록페이지 이동
  const onList = () => {
    history.push({
      pathname: '/haccp/monitoring/production/result',
      state: state
    });
  };

  // PDF파일 열기
  const onPdfOpen = () => {
    const url = requestInfo.orgnlFilePathValue;
    if (url === null) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: 'PDF파일이 존재하지 않습니다.',
        isConfirmBtn: true
      });
      return;
    }

    const { REACT_APP_API_URL_SFSH } = process.env || {};
    const pdfUrl = `${REACT_APP_API_URL_SFSH}/sfsh/fileView/pdf?filePath=${url}`;
    window.open(pdfUrl, '_blank');
  };

  // 검사결과 상세 Api 호출
  const onDetail = async () => {
    const response = await resultDetail(seq);

    const { code, data = {}, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    const { inspResultIrdntList = [], inspResultDetailMstList = [] } =
      data || {};

    // 의뢰정보
    setRequestInfo(data);
    // 검사결과 원본데이터
    setOriginData(inspResultIrdntList);
    // 검사결과데이터
    setResultData(inspResultDetailMstList);
  };

  /* watch */
  useEffect(() => {
    // 상세API 호출
    onDetail();
  }, [seq]);

  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center g-2">
            <Col>
              <h5 className="mb-0">검사결과 상세</h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Flex className="mb-3">
            <h6 className="fs-0">의뢰정보</h6>
            <Button size="sm" className="ms-auto" onClick={() => onPdfOpen()}>
              PDF
            </Button>
          </Flex>
          <Table bordered className="fs--1 text-center">
            <tbody>
              {/* 시료분석 결과 */}
              {requestInfo.inspResultType === 1 && (
                <>
                  <tr>
                    <th className="bg-200 text-700">공장</th>
                    <td>{requestInfo.pltNm || '-'}</td>
                    <th className="bg-200 text-700">검사분류유형</th>
                    <td>{requestInfo.ctgryGrpNm || '-'}</td>
                    <th className="bg-200 text-700">품목코드</th>
                    <td>{requestInfo.sampleCd || '-'}</td>
                    <th className="bg-200 text-700">품목명</th>
                    <td>{requestInfo.sampleNm || '-'}</td>
                  </tr>
                  <tr>
                    <th className="bg-200 text-700">접수번호</th>
                    <td>{requestInfo.rcptNoVl || '-'}</td>
                    <th className="bg-200 text-700">접수일</th>
                    <td>{requestInfo.rcptYmd || '-'}</td>
                    <th className="bg-200 text-700">의뢰일</th>
                    <td>{requestInfo.inspReqDt || '-'}</td>
                    <th className="bg-200 text-700"></th>
                    <td></td>
                  </tr>
                </>
              )}
              {/* 성분분석 결과 */}
              {requestInfo.inspResultType === 2 && (
                <>
                  <tr>
                    <th className="bg-200 text-700">공장</th>
                    <td>{requestInfo.pltNm || '-'}</td>
                    <th className="bg-200 text-700">검사분류유형</th>
                    <td>{requestInfo.ctgryGrpNm || '-'}</td>
                    <th className="bg-200 text-700">제품코드</th>
                    <td>{requestInfo.sampleCd || '-'}</td>
                    <th className="bg-200 text-700">제품명</th>
                    <td>{requestInfo.sampleNm || '-'}</td>
                  </tr>
                  <tr>
                    <th className="bg-200 text-700">사료명</th>
                    <td>{requestInfo.feedNm || '-'}</td>
                    <th className="bg-200 text-700">접수번호</th>
                    <td>{requestInfo.rcptNoVl || '-'}</td>
                    <th className="bg-200 text-700">접수일자</th>
                    <td>{requestInfo.rcptYmd || '-'}</td>
                    <th className="bg-200 text-700">통보일자</th>
                    <td>{requestInfo.ntfctnYmd || '-'}</td>
                  </tr>
                </>
              )}
              {/* 동물성단백질 결과 */}
              {requestInfo.inspResultType === 3 && (
                <>
                  <tr>
                    <th className="bg-200 text-700">공장</th>
                    <td>{requestInfo.pltNm || '-'}</td>
                    <th className="bg-200 text-700">검사분류유형</th>
                    <td>{requestInfo.ctgryGrpNm || '-'}</td>
                    <th className="bg-200 text-700">시료명</th>
                    <td>{requestInfo.sampleNm || '-'}</td>
                    <th className="bg-200 text-700">축종명</th>
                    <td>{requestInfo.anispNm || '-'}</td>
                  </tr>
                  <tr>
                    <th className="bg-200 text-700">기준월</th>
                    <td>{`${requestInfo.baseM}월` || '-'}</td>
                    <th className="bg-200 text-700">채취일자</th>
                    <td>{requestInfo.coltYmd || '-'}</td>
                    <th className="bg-200 text-700">축종명</th>
                    <td>{requestInfo.anispNm || '-'}</td>
                    <th className="bg-200 text-700">단계명</th>
                    <td>{requestInfo.stgNm || '-'}</td>
                  </tr>
                </>
              )}
              {/* 위생검사 결과 */}
              {requestInfo.inspResultType === 4 && (
                <>
                  <tr>
                    <th className="bg-200 text-700">공장</th>
                    <td>{requestInfo.pltNm || '-'}</td>
                    <th className="bg-200 text-700">검사분류유형</th>
                    <td>{requestInfo.ctgryGrpNm || '-'}</td>
                    <th className="bg-200 text-700">축종</th>
                    <td>{requestInfo.anispNm || '-'}</td>
                    <th className="bg-200 text-700">채취일자</th>
                    <td>{requestInfo.coltYmd || '-'}</td>
                  </tr>

                  <tr>
                    <th className="bg-200 text-700">시료코드</th>
                    <td>{requestInfo.sampleCd || '-'}</td>
                    <th className="bg-200 text-700">시료명</th>
                    <td>{requestInfo.sampleNm || '-'}</td>
                    <th className="bg-200 text-700">접수번호</th>
                    <td>{requestInfo.rcptNoVl || '-'}</td>
                    <th className="bg-200 text-700">발송일자</th>
                    <td>{requestInfo.sendYmd || '-'}</td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
          {/* 검사결과 원본 데이터 */}
          <h6 className="fs-0 mb-3">검사결과 원본 데이터</h6>
          {originData.length > 0 && (
            <div className="scrollbar">
              <Table bordered className="fs--1 text-center">
                <thead className="bg-200 text-700 align-middle border-300">
                  <tr>
                    <th className="text-nowrap">검사항목</th>
                    {originData?.map(
                      ({ inspIrdntNm, inspResultIrdntNm }, index) => (
                        <th className="text-nowrap" key={index}>
                          {inspIrdntNm || inspResultIrdntNm}
                        </th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="bg-200 text-700">검사결과</th>
                    {originData?.map(({ inspResultVal }, index) => (
                      <th className="text-nowrap" key={index}>
                        {inspResultVal || '-'}
                      </th>
                    ))}
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
          {originData.length < 1 && (
            <Table bordered className="fs--1 text-center">
              <tbody>
                <tr>
                  <th>검사결과 원본데이터가 존재하지 않습니다.</th>
                </tr>
              </tbody>
            </Table>
          )}
          {/* 검사결과 */}
          <h6 className="fs-0 mb-3">검사결과</h6>
          <div className="max-vh-50 scrollbar">
            {resultData?.map(
              ({ inspStanNm, inspResultDetailSubList = [] }, index) => (
                <Fragment key={index}>
                  <p className="fs--1 text-dark mb-3">{inspStanNm || '-'}</p>
                  {inspResultDetailSubList?.length > 0 && (
                    <Table bordered className="fs--1 text-center mb-3">
                      <thead className="bg-200 text-700 align-middle border-300">
                        <tr>
                          <th rowSpan={3} className="text-nowrap"></th>
                          {inspResultDetailSubList?.map(
                            ({ inspIrdntNm, ccpYn }, index) => (
                              <th
                                colSpan={2}
                                className="text-nowrap"
                                key={index}
                              >
                                {inspIrdntNm || '-'} {ccpYn === 'Y' && '/ CCP'}
                              </th>
                            )
                          )}
                        </tr>
                        <tr>
                          {inspResultDetailSubList?.map(
                            ({ inspTypeNm }, index) => (
                              <Fragment key={index}>
                                <th colSpan={2} className="text-nowrap">
                                  {inspTypeNm || '-'}
                                </th>
                              </Fragment>
                            )
                          )}
                        </tr>
                        <tr>
                          {inspResultDetailSubList?.map(({ key }, index) => (
                            <Fragment key={index}>
                              <th className="text-nowrap">한계기준</th>
                              <th className="text-nowrap">상태</th>
                            </Fragment>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <th className="text-nowrap">월</th>
                          {inspResultDetailSubList?.map(
                            ({ limitMt, limitMtSts }, index) => (
                              <Fragment key={index}>
                                <td className="text-nowrap">
                                  {limitMt || '-'}
                                </td>
                                <td
                                  className={
                                    limitMtSts === '기준치 이탈'
                                      ? 'text-nowrap text-danger fw-bolder'
                                      : 'text-nowrap'
                                  }
                                >
                                  {limitMtSts || '-'}
                                </td>
                              </Fragment>
                            )
                          )}
                        </tr>
                        <tr>
                          <th className="text-nowrap">분기</th>
                          {inspResultDetailSubList?.map(
                            ({ limitQt, limitQtSts }, index) => (
                              <Fragment key={index}>
                                <td className="text-nowrap">
                                  {limitQt || '-'}
                                </td>
                                <td
                                  className={
                                    limitQtSts === '기준치 이탈'
                                      ? 'text-nowrap text-danger fw-bolder'
                                      : 'text-nowrap'
                                  }
                                >
                                  {limitQtSts || '-'}
                                </td>
                              </Fragment>
                            )
                          )}
                        </tr>
                        <tr>
                          <th className="text-nowrap">반기</th>
                          {inspResultDetailSubList?.map(
                            ({ limitHf, limitHfSts }, index) => (
                              <Fragment key={index}>
                                <td className="text-nowrap">
                                  {limitHf || '-'}
                                </td>
                                <td
                                  className={
                                    limitHfSts === '기준치 이탈'
                                      ? 'text-nowrap text-danger fw-bolder'
                                      : 'text-nowrap'
                                  }
                                >
                                  {limitHfSts || '-'}
                                </td>
                              </Fragment>
                            )
                          )}
                        </tr>
                        <tr>
                          <th className="text-nowrap">연</th>
                          {inspResultDetailSubList?.map(
                            ({ limitOy, limitOySts }, index) => (
                              <Fragment key={index}>
                                <td className="text-nowrap">
                                  {limitOy || '-'}
                                </td>
                                <td
                                  className={
                                    limitOySts === '기준치 이탈'
                                      ? 'text-nowrap text-danger fw-bolder'
                                      : 'text-nowrap'
                                  }
                                >
                                  {limitOySts || '-'}
                                </td>
                              </Fragment>
                            )
                          )}
                        </tr>
                      </tbody>
                    </Table>
                  )}
                  {inspResultDetailSubList?.length < 1 && (
                    <Table bordered className="fs--1 text-center">
                      <tbody>
                        <tr>
                          <th>한계기준정보가 존재하지 않습니다.</th>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </Fragment>
              )
            )}
            {resultData?.length < 1 && (
              <Table bordered className="fs--1 text-center">
                <tbody>
                  <tr>
                    <th>검사결과 데이터가 존재하지 않습니다.</th>
                  </tr>
                </tbody>
              </Table>
            )}
          </div>
        </Card.Body>
        <Card.Footer className="d-flex align-items-center">
          <Button
            size="sm"
            variant="secondary"
            className="ms-auto"
            onClick={() => onList()}
          >
            이전
          </Button>
        </Card.Footer>
      </Card>
    </>
  );
};

export default Detail;
